import Box from '@mui/material/Box';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableHead from '@mui/material/TableHead';
import MuiTableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import { useI18n } from 'locales';
import PropTypes from 'prop-types';

function TableHead({ headCells, order, orderBy, onRequestSort, showSelect }) {
  const t = useI18n();

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <MuiTableHead>
      <MuiTableRow>
        {
          showSelect && (
            <MuiTableCell padding="checkbox">
              {/* <Checkbox
                color="primary"
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
              /> */}
            </MuiTableCell>
          )
        }
        {headCells.map((headCell, index) => (
          <MuiTableCell
            key={`table-head-cell-${index}`}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{
              minWidth: headCell.width ? headCell.width : undefined,
            }}
          >
            {
              (headCell.disableSort || headCell.type === 'actions') ? (
                <>
                  {t(headCell.label)}
                </>
              ) : (
                <TableSortLabel
                  active={orderBy === (headCell.id)}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {t(headCell.label)}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              )
            }
          </MuiTableCell>
        ))}
      </MuiTableRow>
    </MuiTableHead>
  );
}

TableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default TableHead;
